import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.string.trim.js";
import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useCallbackRef from 'hooks/useCallbackRef';
export var VIEW_KEYS = {
  DEFAULT: 'default',
  SELECTED: 'selected',
  SEARCH: 'search'
};
function useItemPickerView(_ref) {
  var title = _ref.title,
    searchValue = _ref.searchValue,
    clearSearchValue = _ref.clearSearchValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var views = {
    default: {
      title: title,
      key: VIEW_KEYS.DEFAULT,
      onGoBack: false
    },
    selected: {
      title: t('selection'),
      key: VIEW_KEYS.SELECTED,
      onGoBack: VIEW_KEYS.DEFAULT
    },
    search: {
      title: t('search_results_title'),
      key: VIEW_KEYS.SEARCH,
      onGoBack: VIEW_KEYS.DEFAULT
    }
  };
  var _useState = useState(VIEW_KEYS.DEFAULT),
    _useState2 = _slicedToArray(_useState, 2),
    viewKey = _useState2[0],
    setViewKey = _useState2[1];

  // Assigning the clearSearchValue to a ref so it doesn't invalidate the useCallback
  var clearSearchValueRef = useCallbackRef(clearSearchValue);
  var changeView = useCallback(function (newKey) {
    setViewKey(newKey);

    // Empty search field when changing views while search field is populated
    if (viewKey !== VIEW_KEYS.SEARCH) {
      clearSearchValueRef.current();
    }
  }, [viewKey, clearSearchValueRef]);
  useEffect(function () {
    if (searchValue.trim()) {
      setViewKey(VIEW_KEYS.SEARCH);
    } else {
      setViewKey(VIEW_KEYS.DEFAULT);
    }
  }, [searchValue]);
  return {
    view: views[viewKey],
    changeView: changeView,
    isDefaultView: viewKey === VIEW_KEYS.DEFAULT,
    isSelectionView: viewKey === VIEW_KEYS.SELECTED,
    isSearchView: viewKey === VIEW_KEYS.SEARCH
  };
}
export default useItemPickerView;